// NOTE:
// This component has changed from using emotion css to using matchmeia and solely a JS approach

import React, { useEffect, useState } from "react";

interface ResponsiveProps {
  below?: number;
  above?: number;
  middle?: { min: number; max: number };
  children: React.ReactNode;
}

const Responsive: React.FC<ResponsiveProps> = ({
  below,
  above,
  middle,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkVisibility = () => {
      const width = window.innerWidth;

      const matchesBefore = below !== undefined ? width <= below : true;
      const matchesAfter = above !== undefined ? width >= above : true;
      const matchesMiddle = middle
        ? width >= middle.min && width <= middle.max
        : true;

      setIsVisible(matchesBefore && matchesAfter && matchesMiddle);
    };

    checkVisibility();
    window.addEventListener("resize", checkVisibility);
    return () => window.removeEventListener("resize", checkVisibility);
  }, [below, above, middle]);

  return isVisible ? <>{children}</> : null;
};

export default Responsive;

// Example Usage
/* <Responsive before={480}>
  <div>Visible only on screens smaller than 480px.</div>
</Responsive>

<Responsive after={1024}>
  <div>Visible only on screens larger than 1024px.</div>
</Responsive>

<Responsive middle={{ min: 481, max: 1024 }}>
  <div>Visible only on tablet screens (481px to 1024px).</div>
</Responsive> */
